import validator from "validator";

const validationEmail = (email?: string) => {
  if (!email) return false;
  return validator.isEmail(email);
};

export default validationEmail;
